
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","fill":"#FFC93C"}}),_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M18.765 11.259l-6.282-5.724a.715.715 0 00-.967 0L5.235 11.26a.713.713 0 00-.186.79c.108.278.37.458.67.458h1.003v5.735c0 .227.184.412.412.412h3.442a.412.412 0 00.412-.412V14.76h2.024v3.482c0 .227.184.412.411.412h3.443a.412.412 0 00.412-.412v-5.735h1.003c.3 0 .562-.18.67-.458a.714.714 0 00-.186-.79z","fill":"#FFF8DD"}}),_c('path',{attrs:{"d":"M17.17 6.168h-2.764l3.176 2.889V6.58a.412.412 0 00-.411-.412z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(5 5)","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    